import script from "./cockpit.vue?vue&type=script&setup=true&lang=ts"
export * from "./cockpit.vue?vue&type=script&setup=true&lang=ts"

import "./cockpit.vue?vue&type=style&index=0&id=3100da5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3100da5e"]])

export default __exports__